import { login, getInfo, loginEmail, logout } from '@/api/user'
import { Message } from 'element-ui'
import { setToken, removeToken } from '@/store/local/auth'

const getDefaultState = () => {
  return {
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
/*   loginEmail({ commit }, data) {
    const { mobile, code } = data
    return new Promise((resolve, reject) => {
      loginEmail({ mobile: mobile, code: code })
        .then(response => {
          if (response.data.code == 1) {
            setToken(response.data.data.token)
            location.reload()
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
    })
  }, */
  loginEmail({ commit }, data) {
    const { mobile, code } = data;
    return new Promise((resolve, reject) => {
      loginEmail({ mobile, code })
        .then(response => {
          if (response.data.code === 1) {
            const { token, name, avatar } = response.data.data;
            setToken(token);
            commit('SET_NAME', name); // 同步更新用户信息
            commit('SET_AVATAR', avatar);
            Message({
              message: '您已成功登录，用户：' +  response.data.data.account,
              type: 'success',
              duration: 5 * 1000
            })
            resolve(response.data); // 返回数据供组件使用
          } else {
            reject(new Error('登录失败：' + response.data.message));
          }
        })
        .catch(error => reject(error));
    });
  },

  // TODO: user login 用户登录，获取到token、name和avatar
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        setToken(data.token)
        commit('SET_NAME', data.name)
        commit('SET_AVATAR', data.avatar)
        Message({
          message: '您已成功登录，用户：' + data.token,
          type: 'success',
          duration: 5 * 1000
        })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // TODO: get user info 用户修改账号信息后重新获取name和avatar
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response
  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }
  //       const { name, avatar } = data
  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        if (!data) {
          return reject('获取用户信息失败，请重新登录')
        }
        const { name, avatar } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout 用户登出，重设状态
  logout({ commit }) {
    return new Promise(() => {
      logout().then(response => {
        if (response.data.code == 1) {
          removeToken()
          commit('RESET_STATE')
          location.reload()
        }
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

